import React from 'react';
import { Button, Input, InputNumber, Select } from 'antd';

export function buildTitleBarTab(context) {
  const { shouldShowPage, handleSaveSystemSettings, updateSystemSettings, systemSettings } = context;
  if (!shouldShowPage('标题栏设置')) return null;
  if (!systemSettings?.titleBar) return null;

  return {
    key: 'title_bar',
    label: '标题栏设置',
    children: (
      <div>
        <h3>标题栏设置</h3>
        <p style={{ color: '#888', marginBottom: 12, fontSize: 13 }}>
          此处是全站默认；队伍专属文案请到「队伍品牌」。
        </p>
        <div style={{ marginBottom: 16 }}>
          <Button type="primary" onClick={handleSaveSystemSettings}>保存设置</Button>
          <Button style={{ marginLeft: 8 }} onClick={() => {
            updateSystemSettings(settings => ({
              ...settings,
              titleBar: {
                text: '龙泉市户外应急救援队 - 现场指挥中心',
                height: 60,
                fontSize: 24,
                backgroundColor: '#2c3e50',
                textColor: '#ffffff',
                letterSpacing: 0,
                fontWeight: 'bold',
                show: true
              },
              mobileTitleBar: {
                text: '龙泉市户外应急救援队 - 现场指挥中心',
                height: 50,
                fontSize: 18,
                backgroundColor: '#2c3e50',
                textColor: '#ffffff',
                letterSpacing: 0,
                fontWeight: 'bold',
                show: true
              }
            }));
          }}>重置默认</Button>
        </div>

        <div style={{ marginBottom: 24 }}>
          <h4 style={{ color: '#1890ff', borderBottom: '2px solid #1890ff', paddingBottom: 8 }}>PC端设置</h4>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <div>
              <h4>标题文本</h4>
              <Input
                value={systemSettings.titleBar.text}
                onChange={e => updateSystemSettings(settings => ({
                  ...settings,
                  titleBar: { ...settings.titleBar, text: e.target.value }
                }))}
                placeholder="输入标题文本"
              />
            </div>
            <div>
              <h4>高度 (像素)</h4>
              <InputNumber
                value={systemSettings.titleBar.height}
                onChange={value => updateSystemSettings(settings => ({
                  ...settings,
                  titleBar: { ...settings.titleBar, height: value }
                }))}
                min={40}
                max={120}
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <h4>字体大小 (像素)</h4>
              <InputNumber
                value={systemSettings.titleBar.fontSize}
                onChange={value => updateSystemSettings(settings => ({
                  ...settings,
                  titleBar: { ...settings.titleBar, fontSize: value }
                }))}
                min={12}
                max={48}
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <h4>字间距 (像素)</h4>
              <InputNumber
                value={systemSettings.titleBar.letterSpacing}
                onChange={value => updateSystemSettings(settings => ({
                  ...settings,
                  titleBar: { ...settings.titleBar, letterSpacing: value }
                }))}
                min={-2}
                max={10}
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <h4>字体粗细</h4>
              <Select
                value={systemSettings.titleBar.fontWeight}
                onChange={value => updateSystemSettings(settings => ({
                  ...settings,
                  titleBar: { ...settings.titleBar, fontWeight: value }
                }))}
                style={{ width: '100%' }}
              >
                <Select.Option value="normal">正常</Select.Option>
                <Select.Option value="bold">粗体</Select.Option>
                <Select.Option value="bolder">更粗</Select.Option>
                <Select.Option value="lighter">细体</Select.Option>
              </Select>
            </div>
            <div>
              <h4>显示状态</h4>
              <Select
                value={systemSettings.titleBar.show ? 'show' : 'hide'}
                onChange={value => updateSystemSettings(settings => ({
                  ...settings,
                  titleBar: { ...settings.titleBar, show: value === 'show' }
                }))}
                style={{ width: '100%' }}
              >
                <Select.Option value="show">显示</Select.Option>
                <Select.Option value="hide">隐藏</Select.Option>
              </Select>
            </div>
            <div>
              <h4>背景颜色</h4>
              <Input
                value={systemSettings.titleBar.backgroundColor}
                onChange={e => updateSystemSettings(settings => ({
                  ...settings,
                  titleBar: { ...settings.titleBar, backgroundColor: e.target.value }
                }))}
                placeholder="#2c3e50"
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <h4>文字颜色</h4>
              <Input
                value={systemSettings.titleBar.textColor}
                onChange={e => updateSystemSettings(settings => ({
                  ...settings,
                  titleBar: { ...settings.titleBar, textColor: e.target.value }
                }))}
                placeholder="#ffffff"
                style={{ width: '100%' }}
              />
            </div>
          </div>
        </div>

        <div style={{ marginBottom: 24 }}>
          <h4 style={{ color: '#52c41a', borderBottom: '2px solid #52c41a', paddingBottom: 8 }}>手机端设置</h4>
          <div style={{ display: 'grid', gridTemplateColumns: '1fr 1fr', gap: 16 }}>
            <div>
              <h4>标题文本</h4>
              <Input
                value={systemSettings.mobileTitleBar?.text || '龙泉市户外应急救援队 - 现场指挥中心'}
                onChange={e => updateSystemSettings(settings => ({
                  ...settings,
                  mobileTitleBar: { ...(settings.mobileTitleBar || {}), text: e.target.value }
                }))}
                placeholder="输入标题文本"
              />
            </div>
            <div>
              <h4>高度 (像素)</h4>
              <InputNumber
                value={systemSettings.mobileTitleBar?.height || 50}
                onChange={value => updateSystemSettings(settings => ({
                  ...settings,
                  mobileTitleBar: { ...(settings.mobileTitleBar || {}), height: value }
                }))}
                min={30}
                max={80}
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <h4>字体大小 (像素)</h4>
              <InputNumber
                value={systemSettings.mobileTitleBar?.fontSize || 18}
                onChange={value => updateSystemSettings(settings => ({
                  ...settings,
                  mobileTitleBar: { ...(settings.mobileTitleBar || {}), fontSize: value }
                }))}
                min={12}
                max={32}
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <h4>字间距 (像素)</h4>
              <InputNumber
                value={systemSettings.mobileTitleBar?.letterSpacing || 0}
                onChange={value => updateSystemSettings(settings => ({
                  ...settings,
                  mobileTitleBar: { ...(settings.mobileTitleBar || {}), letterSpacing: value }
                }))}
                min={-2}
                max={10}
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <h4>字体粗细</h4>
              <Select
                value={systemSettings.mobileTitleBar?.fontWeight || 'bold'}
                onChange={value => updateSystemSettings(settings => ({
                  ...settings,
                  mobileTitleBar: { ...(settings.mobileTitleBar || {}), fontWeight: value }
                }))}
                style={{ width: '100%' }}
              >
                <Select.Option value="normal">正常</Select.Option>
                <Select.Option value="bold">粗体</Select.Option>
                <Select.Option value="bolder">更粗</Select.Option>
                <Select.Option value="lighter">细体</Select.Option>
              </Select>
            </div>
            <div>
              <h4>显示状态</h4>
              <Select
                value={(systemSettings.mobileTitleBar?.show !== false) ? 'show' : 'hide'}
                onChange={value => updateSystemSettings(settings => ({
                  ...settings,
                  mobileTitleBar: { ...(settings.mobileTitleBar || {}), show: value === 'show' }
                }))}
                style={{ width: '100%' }}
              >
                <Select.Option value="show">显示</Select.Option>
                <Select.Option value="hide">隐藏</Select.Option>
              </Select>
            </div>
            <div>
              <h4>背景颜色</h4>
              <Input
                value={systemSettings.mobileTitleBar?.backgroundColor || '#2c3e50'}
                onChange={e => updateSystemSettings(settings => ({
                  ...settings,
                  mobileTitleBar: { ...(settings.mobileTitleBar || {}), backgroundColor: e.target.value }
                }))}
                placeholder="#2c3e50"
                style={{ width: '100%' }}
              />
            </div>
            <div>
              <h4>文字颜色</h4>
              <Input
                value={systemSettings.mobileTitleBar?.textColor || '#ffffff'}
                onChange={e => updateSystemSettings(settings => ({
                  ...settings,
                  mobileTitleBar: { ...(settings.mobileTitleBar || {}), textColor: e.target.value }
                }))}
                placeholder="#ffffff"
                style={{ width: '100%' }}
              />
            </div>
          </div>
        </div>

        <div style={{ marginTop: 16, padding: 16, border: '1px solid #d9d9d9', borderRadius: 6, backgroundColor: '#fafafa' }}>
          <h4>预览效果</h4>
          <div style={{
            height: `${systemSettings.titleBar.height}px`,
            backgroundColor: systemSettings.titleBar.backgroundColor,
            color: systemSettings.titleBar.textColor,
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: `${systemSettings.titleBar.fontSize}px`,
            fontWeight: systemSettings.titleBar.fontWeight,
            letterSpacing: `${systemSettings.titleBar.letterSpacing}px`,
            borderRadius: 4,
            marginBottom: 8
          }}>
            {systemSettings.titleBar.text}
          </div>
          <div style={{
            height: `${systemSettings.mobileTitleBar?.height || 50}px`,
            backgroundColor: systemSettings.mobileTitleBar?.backgroundColor || '#2c3e50',
            color: systemSettings.mobileTitleBar?.textColor || '#ffffff',
            display: 'flex',
            alignItems: 'center',
            justifyContent: 'center',
            fontSize: `${systemSettings.mobileTitleBar?.fontSize || 18}px`,
            fontWeight: systemSettings.mobileTitleBar?.fontWeight || 'bold',
            letterSpacing: `${systemSettings.mobileTitleBar?.letterSpacing || 0}px`,
            borderRadius: 4,
            maxWidth: '300px'
          }}>
            {systemSettings.mobileTitleBar?.text || systemSettings.titleBar.text}
          </div>
        </div>
      </div>
    )
  };
}
